import { CodeValidationCodeAnalysisResult, CodeValidationRuleAnalysis } from '.';

export default class CodeValidationContext {
    codeAnalysisResult: CodeValidationCodeAnalysisResult;
    ruleAnalysis: CodeValidationRuleAnalysis[];

    constructor(codeAnalysisResult: CodeValidationCodeAnalysisResult, ruleAnalysis: CodeValidationRuleAnalysis[]) {
        this.codeAnalysisResult = codeAnalysisResult;
        this.ruleAnalysis = ruleAnalysis;
    }

    fetchRuleErrors(rulePath: string): CodeValidationRuleAnalysis | undefined {
        return this.ruleAnalysis.find(
            rule =>
                rule.rule_path === rulePath && (rule.analysis_status === 'FAIL' || rule.analysis_status === 'WARNING')
        );
    }

    fetchRulesWithIssues(): CodeValidationRuleAnalysis[] {
        return this.ruleAnalysis.filter(rule => rule.analysis_status === 'FAIL' || rule.analysis_status === 'WARNING');
    }

    hasWarnings(): boolean {
        return this.ruleAnalysis.some(rule => rule.analysis_status === 'WARNING');
    }

    hasErrors(): boolean {
        return this.ruleAnalysis.some(rule => rule.analysis_status === 'FAIL');
    }
}
